import type { TranslateOptions } from '@winnin/i18n'

import { PATHNAMES } from 'utils/routes/consts'
import TOLGEE_GLOBALS from 'utils/tolgeeGlobals'

import type { TerritoryEntity, TerritoryEntityType } from './types'

export const TERRITORY_ENTITIES = {
  'saved-search': 'saved-search',
  brand: 'brand_territory',
  'brand-group': 'brand_group',
  topic: 'topic',
  subtopic: 'subtopic',
  niche: 'niche',
  'trending-tag': 'trending_subject',
  trending: 'trending',
  tag: 'tag',
  'hot-topic': 'hot_topic',
  'global-topic': 'global_topic',
  theme: 'theme',
  segment: 'segment',
  subject: 'subject',
  'entity-query': 'entity_query',
  entity: 'entity',
} satisfies Record<TerritoryEntity, TerritoryEntityType>

const SAVED_SEARCH_PATHS = [PATHNAMES.OUTDATED_SAVED_SEARCH, PATHNAMES.WORKSPACE_SAVED_SEARCH]
const BRAND_PATHS = [
  '/workspace/:panelId/brand/:entityId?',
  PATHNAMES.WORKSPACE_BRAND,
  PATHNAMES.WORKSPACE_BRAND_OVERVIEW,
]
const BRAND_GROUP_PATHS = ['/workspace/:panelId/brand-group/:entityId?', PATHNAMES.WORKSPACE_BRAND_GROUP]
const TOPIC_PATHS = ['/topic/:entityId?', PATHNAMES.TOPIC, PATHNAMES.WORKSPACE_TOPIC]
const SUBTOPIC_PATHS = ['/subtopic/:entityId?', PATHNAMES.SUBTOPIC, PATHNAMES.WORKSPACE_SUBTOPIC]
const NICHE_PATHS = [
  '/workspace/:panelId/niche/:entityId',
  PATHNAMES.WORKSPACE_NICHE,
  PATHNAMES.WORKSPACE_CATEGORY_NICHE,
]
const TRENDING_TAG_PATHS = [PATHNAMES.TRENDING_TAG, PATHNAMES.OUTDATED_TRENDING_TAG, PATHNAMES.WORKSPACE_TRENDING_TAG]
const TRENDING_PATHS = ['/workspace/:panelId/trending/:entityId?', PATHNAMES.WORKSPACE_TRENDING]
const TAG_PATHS = ['/workspace/:panelId/tag/:entityId?', PATHNAMES.WORKSPACE_TAG]

export const PATHS_BY_ENTITY_TYPE = {
  'saved-search': SAVED_SEARCH_PATHS,
  brand: BRAND_PATHS,
  'brand-group': BRAND_GROUP_PATHS,
  topic: TOPIC_PATHS,
  subtopic: SUBTOPIC_PATHS,
  niche: NICHE_PATHS,
  'trending-tag': TRENDING_TAG_PATHS,
  trending: TRENDING_PATHS,
  tag: TAG_PATHS,
  'hot-topic': [PATHNAMES.WORKSPACE_HOT_TOPIC],
  'global-topic': [PATHNAMES.WORKSPACE_GLOBAL_TOPIC],
  theme: [PATHNAMES.WORKSPACE_THEME],
  segment: [PATHNAMES.WORKSPACE_SEGMENT],
  subject: [PATHNAMES.WORKSPACE_SUBJECT],
  'entity-query': [PATHNAMES.WORKSPACE_ENTITY_QUERY],
  entity: [PATHNAMES.WORKSPACE_ENTITY],
} satisfies Record<TerritoryEntity, string[]>

export const GLOBAL_TAXONOMY_PATHNAMES_BY_TYPE = {
  theme: PATHNAMES.WORKSPACE_THEME,
  segment: PATHNAMES.WORKSPACE_SEGMENT,
  subject: PATHNAMES.WORKSPACE_SUBJECT,
  entity_query: PATHNAMES.WORKSPACE_ENTITY_QUERY,
  entity: PATHNAMES.WORKSPACE_ENTITY,
} as const

export const GLOBAL_TAXONOMY_TYPES_BY_TYPENAME = {
  TaxonomyTheme: 'theme',
  TaxonomySegment: 'segment',
  TaxonomySubject: 'subject',
  TaxonomyEntityQuery: 'entity_query',
  TaxonomyEntity: 'entity',
} as const satisfies Record<string, keyof typeof GLOBAL_TAXONOMY_PATHNAMES_BY_TYPE>

export const territoryTypeToTolgee: Record<TerritoryEntityType, TranslateOptions> = {
  topic: TOLGEE_GLOBALS.topic,
  subtopic: TOLGEE_GLOBALS.topic,
  niche: TOLGEE_GLOBALS.niche,
  saved_search: TOLGEE_GLOBALS.ownedTopic,
  'saved-search': TOLGEE_GLOBALS.ownedTopic,
  brand_territory: TOLGEE_GLOBALS.brand,
  trending_subject: TOLGEE_GLOBALS.trending,
  trending: TOLGEE_GLOBALS.trending,
  brand_group: TOLGEE_GLOBALS.brand,
  tag: TOLGEE_GLOBALS.tag,
  industry_topic: TOLGEE_GLOBALS.category,
  hot_topic: TOLGEE_GLOBALS.hotTopic,
  global_topic: TOLGEE_GLOBALS.topic,
  event: TOLGEE_GLOBALS.liveEvents,
  theme: TOLGEE_GLOBALS.topic,
  segment: TOLGEE_GLOBALS.topic,
  subject: TOLGEE_GLOBALS.topic,
  entity_query: TOLGEE_GLOBALS.topic,
  entity: TOLGEE_GLOBALS.topic,
}
